import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.newPalette.neutral.N200};
`;

export const Container = styled.div`
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold}
  margin-top: 20px;
  text-align: center;
`;

export const Description = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  margin-top: 20px;
  text-align: center;

  a {
    color: red;
    color: ${(props) => props.theme.newPalette.turquoise.T300};
  }
`;
